import { Info } from "lucide-react";

export const DemoNote = ({ show }) =>
  show ? (
    <p className="mt-3 inline-flex items-start gap-1.5 rounded-xl bg-[var(--bone-2)] px-3 py-2 text-xs text-[var(--stone-dark)]" data-testid="demo-scenario-note">
      <Info size={13} className="mt-0.5 shrink-0" /> Demo scenario: the resident, supporters and owner are demo accounts.
    </p>
  ) : null;
